var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-10.76 0 103.5 103.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-284.712 -235.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M325.8,239.2c26,0,37,9.3,37,9.3v73.4c0,1.9-11.9,12.7-37,12.7-22.9,0-37-10.3-37-12.7V248.5s6.9-9.3,37-9.3m0-4c-31.2,0-39.3,9.9-40.2,11a4.069,4.069,0,0,0-.8,2.4V322c0,4.8,8.6,9.2,12.3,10.9a70.668,70.668,0,0,0,28.7,5.8c14.1,0,23.9-3.3,29.6-6,2.7-1.3,11.3-5.8,11.3-10.6V248.7a3.749,3.749,0,0,0-1.4-3c-.5-.6-12.4-10.5-39.5-10.5Z",
    fill: "#2b4ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M363.5,272.3s-13.3,9.7-37.7,9.7c-24.5,0-38-9.7-38-9.7",
    fill: "none",
    stroke: "#2b4ea2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M363.4,295.9s-13.2,9.7-37.7,9.7-38.2-9.7-38.2-9.7",
    fill: "none",
    stroke: "#2b4ea2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M302.5,254.2a3.372,3.372,0,0,1,3.9,3.9,3.189,3.189,0,0,1-2.6,2.6,3.372,3.372,0,0,1-3.9-3.9A3.606,3.606,0,0,1,302.5,254.2Z",
    fill: "#2b4ea2",
    stroke: "#2b4ea2",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M302.5,287.1a3.372,3.372,0,0,1,3.9,3.9,3.189,3.189,0,0,1-2.6,2.6,3.372,3.372,0,0,1-3.9-3.9A3.313,3.313,0,0,1,302.5,287.1Z",
    fill: "#2b4ea2",
    stroke: "#2b4ea2",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M302.5,313.9a3.372,3.372,0,0,1,3.9,3.9,3.189,3.189,0,0,1-2.6,2.6,3.372,3.372,0,0,1-3.9-3.9A3.452,3.452,0,0,1,302.5,313.9Z",
    fill: "#2b4ea2",
    stroke: "#2b4ea2",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M315.2,261.3c3.2.3,6.6.4,10.1.4,21,0,38.1-5.3,38.1-11.8s-17.1-11.8-38.1-11.8c-10.1,0-20.5,1.1-27.5,3.1",
    fill: "none",
    stroke: "#2b4ea2",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.f5839b82ad6db75bdf4f65d855a977df.svg";
export { ForwardRef as ReactComponent };